import { FormattedMessage } from 'react-intl';
import { InterruptionList } from './components/InterruptionList';
import { CORECON_TEAM } from '../../../../components/utils/roleUtils';
import AuthorisationWrapper from '../../../../components/utils/authorisation/authorisationWrapper';

export const ConnectivityInterruptionHome = () => {
    return (
            <AuthorisationWrapper allowedRoles={[CORECON_TEAM]}>
                <div>
                    <h1 key={'header'}>
                        <FormattedMessage id={'intl-msg:coreconAdminWeb.connectivityInterruption.moduleName'} />
                    </h1>
                    <h5>*Vodafone only</h5>
                    <InterruptionList />
                </div>
            </AuthorisationWrapper>
    );
};